export default "skymp5-front/d4c8845e7680d283d82e9b15bc0fd992.jpg";